import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellyblutrv',
	friendly_name: 'BLU TRV',
	family: 'thermostat',
	modes: {
		thermostat: {
			availableViews: ['advanced'],
			channels: 1,
			settings: [
				{
					title: 'sensor_settings',
					components: [
						{
							title: 'temperature_settings',
							component: 'temperature_settings_blu_trv',
						},
						{
							title: 'attached_sensors',
							component: 'attached_sensors_blu_trv',
						},
					],
				},
				{
					title: 'schedule',
					components: [{ title: 'schedule', component: 'schedules_blu_trv' }],
				},
				webhooks_gen_2,
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'device_name', component: 'device_name_g2' },
						{ title: 'calibration', component: 'calibration_blu_trv' },
						{ title: 'trv_behaviour', component: 'behavior_blu_trv' },
						{
							title: 'trv_interface',
							component: 'interface_blu_trv',
							min_ver: '1.0.1',
						},
						{
							title: 'trv_boost',
							component: 'boost_blu_trv',
							min_ver: '1.0.1',
						},
						{
							title: 'trv_boost_duration_override',
							component: 'boost_duration_override',
							min_ver: '1.0.1',
						},
						{
							title: 'trv_boost_open_window_target_temperature',
							component: 'open_window_target_temperature',
							min_ver: '1.0.1',
						},
						{ title: 'firmware_version', component: 'firmware_update_blu_trv' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
